<template>
	<!-- CS: 매매검색 상세검색 팝업. 매매검색(TotalSearch)과 매수고객 카드(UserDetail)가 같이 쓴다.
	     입력은 복사본(form)에 받고, 검색·닫기 때 부모에게 돌려준다(부모의 입력 상태를 직접 고치지 않는다).
	     조건 조립은 utils/sellSearch.mjs. -->
	<div class="popup-wrap">
		<div class="dim" @click="close"></div>
		<div class="popup lg">
			<div class="popup-tit">
				상세검색
				<button type="button" class="btn btn-close" @click="close"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<table class="table type-input">
					<colgroup>
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
						<col width="5%" />
						<col width="11%" />
					</colgroup>
					<tr>
						<th>검색키워드</th>
						<td colspan="3">
							<input
								class="form-control"
								type="text"
								placeholder="물건명, 주소, 소유자, 전소유자, 전화번호"
								maxlength="80"
								v-model="form.keyword"
							/>
						</td>
						<th>매물상태</th>
						<td colspan="3">
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.st" @change="btnStOption" />
								<span class="checkbox"></span>
								<span class="text">전체</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.st_" :value="'ready'" />
								<span class="checkbox"></span>
								<span class="text">준비</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.st_" :value="'done'" />
								<span class="checkbox"></span>
								<span class="text">매물</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.st_" :value="'hold'" />
								<span class="checkbox"></span>
								<span class="text">보류</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.st_" :value="'sell'" />
								<span class="checkbox"></span>
								<span class="text">매각</span>
							</label>
						</td>
						<th>전화번호</th>
						<td colspan="3">
							<input class="form-control" type="text" v-model="form.phone" />
						</td>
					</tr>
					<tr>
						<th>물건명</th>
						<td colspan="3">
							<input class="form-control" type="text" placeholder="물건명" v-model="form.bName" />
						</td>
						<th>상태</th>
						<td>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.stList" :value="'A'" />
								<span class="checkbox"></span>
								<span class="text">A</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.stList" :value="'B'" />
								<span class="checkbox"></span>
								<span class="text">B</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.stList" :value="'C'" />
								<span class="checkbox"></span>
								<span class="text">C</span>
							</label>
						</td>
						<th>물건번호</th>
						<td>
							<input class="form-control" type="number" placeholder="물건번호" v-model="form.bId" />
						</td>
						<th>매물종류</th>
						<td colspan="3">
							<VueMultiselect
								v-model="form.cateList"
								tag-placeholder="Add this as new tag"
								placeholder="매물종류"
								label="name"
								track-by="id"
								:options="bdCateList"
								:multiple="true"
								:taggable="true"
								deselect-label="Can't remove this value"
							>
								<template v-slot:tag="{ option, remove }">
									<span class="custom__tag">
										<span>
											{{ option.name }}
										</span>
										<span class="custom__remove" @click="remove(option)">&times;</span>
									</span>
								</template>

								<template v-slot:option="props">
									<div class="option__desc">
										<span class="option__title">{{ props.option.name }}</span>
									</div>
								</template>
							</VueMultiselect>
						</td>
					</tr>
					<tr>
						<th>소유자명</th>
						<td colspan="3">
							<input class="form-control" type="text" placeholder="소유자명" v-model="form.oName" />
						</td>
						<th>전소유자명</th>
						<td colspan="3">
							<input class="form-control" type="text" placeholder="전소유자명" v-model="form.preOName" />
						</td>
						<th>매매일자</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="form.sellDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="form.sellDate_E" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>용도지역</th>
						<!-- v-model="form.useList" -->
						<td colspan="3">
							<VueMultiselect
								v-model="form.useList"
								tag-placeholder="Add this as new tag"
								placeholder="용도지역"
								label="name"
								track-by="id"
								:options="useAreaList"
								:multiple="true"
								:taggable="true"
								deselect-label="Can't remove this value"
							>
								<template v-slot:tag="{ option, remove }">
									<span class="custom__tag">
										<span>
											{{ option.name }}
										</span>
										<span class="custom__remove" @click="remove(option)">&times;</span>
									</span>
								</template>

								<template v-slot:option="props">
									<div class="option__desc">
										<span class="option__title">{{ props.option.name }}</span>
									</div>
								</template>
							</VueMultiselect>
							<!-- <select class="form-control">
								<option></option>
							</select> -->
						</td>
						<th>매물금액</th>
						<td colspan="3">
							<input class="form-control xsm" type="number" placeholder="억이상" v-model="form.sellPrice_S" />
							<input class="form-control xsm" type="number" placeholder="억이하" v-model="form.sellPrice_E" />
						</td>
						<th>리모델링일</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="form.remodelDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="form.remodelDate_E" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>대지평수</th>
						<td colspan="3">
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이상"
								v-model="form.lp_S"
								@keyup="form.lm_S = $py_m2_ex(form.lp_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이하"
								v-model="form.lp_E"
								@keyup="form.lm_E = $py_m2_ex(form.lp_E)"
							/>
							<br />
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이상"
								v-model="form.lm_S"
								@keyup="form.lp_S = $m2_py_ex(form.lm_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이하"
								v-model="form.lm_E"
								@keyup="form.lp_E = $m2_py_ex(form.lm_E)"
							/>
						</td>
						<th>건물평수</th>
						<td colspan="3">
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이상"
								v-model="form.sizeP_S"
								@keyup="form.sizeM_S = $py_m2_ex(form.sizeP_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="평이하"
								v-model="form.sizeP_E"
								@keyup="form.sizeM_E = $py_m2_ex(form.sizeP_E)"
							/>
							<br />
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이상"
								v-model="form.sizeM_S"
								@keyup="form.sizeP_S = $m2_py_ex(form.sizeM_S)"
							/>
							<input
								class="form-control xsm"
								type="text"
								placeholder="㎡이하"
								v-model="form.sizeM_E"
								@keyup="form.sizeP_E = $m2_py_ex(form.sizeM_E)"
							/>
						</td>
						<th>준공일자</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="form.buildDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="form.buildDate_E" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>연수익률</th>
						<td colspan="3">
							<input class="form-control xsm" type="number" v-model="form.er_S" />
							%<b-icon-arrow-up />
							<input class="form-control xsm" type="number" v-model="form.er_E" />
							%<b-icon-arrow-down />
						</td>
						<th>도로너비</th>
						<td colspan="3">
							<input class="form-control xsm" type="number" v-model="form.roadWide_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="number" v-model="form.roadWide_E" />
							<b-icon-arrow-down />
							<br />
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.roadConer" :true-value="'Y'" :false-value="''" />
								<span class="checkbox"></span>
								<span class="text">코너</span>
							</label>
							<label class="input-checkbox">
								<input type="checkbox" v-model="form.roadDual" :true-value="'Y'" :false-value="''" />
								<span class="checkbox"></span>
								<span class="text">양면</span>
							</label>
						</td>
						<th>토지평단가</th>
						<td>
							<input class="form-control xsm" type="number" v-model="form.landSizePy" />
							<b-icon-arrow-down />
						</td>
						<th>연면적평단가</th>
						<td>
							<input class="form-control xsm" type="number" v-model="form.totalSizePy" />
							<b-icon-arrow-down />
						</td>
					</tr>
					<tr>
						<th>주변역</th>
						<td>
							<input class="form-control xsm" type="text" v-model="form.sub" />
						</td>
						<th>거리</th>
						<td>
							<input class="form-control xsm" type="text" v-model="form.dis" />
							<b-icon-arrow-down />
						</td>
						<th>도로명</th>
						<td>
							<input class="form-control xsm" type="text" v-model="form.roadName" />
						</td>
						<th>담당자</th>
						<!-- v-model="form.memUid" -->
						<td>
							<select class="form-control select xsm" v-model="form.memUid">
								<option value="">담당자 선택</option>
								<option v-for="m in memList" :key="m.mem_uid" :value="m.mem_uid">
									{{ m.mem_name }} {{ m.mem_rank_name }}
								</option>
							</select>
						</td>
						<th>팀</th>
						<!-- DC: 부서와 팀을 '팀' 하나로 합쳤다. 하위 팀(cateId)은 고르지 않으므로 늘 빈 값이 나간다(요청 문자열은 그대로). -->
						<td colspan="3">
							<select
								v-model="form.teamId"
								class="form-control xsm select"
								@change="form.cateId = ''"
							>
								<option value="" selected>팀</option>
								<option :value="t.ind_cfg_uid" :key="'team_' + t.ind_cfg_uid" v-for="t in teamList">
									{{ t.cfg_val1 }}
								</option>
							</select>
						</td>
					</tr>
					<tr>
						<th>층수</th>
						<td colspan="3">
							<input class="form-control xsm" type="text" placeholder="층이상" v-model="form.floor_S" />
							<input class="form-control xsm" type="text" placeholder="층이하" v-model="form.floor_E" />
						</td>
						<th>매물등록일자</th>
						<td colspan="3">
							<input class="form-control xsm" type="date" v-model="form.regDate_S" />
							<b-icon-arrow-up />
							<input class="form-control xsm" type="date" v-model="form.regDate_E" />
							<b-icon-arrow-down />
						</td>
						<th></th>
						<td colspan="3"></td>
					</tr>
				</table>
				<div class="btn-wrap">
					<button type="button" class="btn btn-btn btn-secondary" @click="$emit('clear')">초기화</button>
					<button type="button" class="btn btn-primary" @click="search">검색</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueMultiselect from 'vue-multiselect';
import { SELL_STATUS_ALL } from '@/utils/sellSearch.mjs';

// 드롭다운 목록은 로그인한 사람마다 한 번만 받는다. 팝업을 열 때마다 다섯 번씩 부르지 않게.
// 담당자 목록(/setting/etc/mem)은 보는 사람에 따라 걸러지는 목록이다(master 전체, 직원은 사내,
// 제휴 게스트는 자기 기관). 로그아웃은 새로고침이 아니라 화면 이동이라 모듈 변수가 남으므로,
// 사람을 키로 두지 않으면 같은 탭에서 다음에 로그인한 사람에게 앞 사람의 명단이 보인다.
let listCache = null;
let listCacheKey = null;

export default {
	name: 'SellDetailSearchPopup',
	components: { VueMultiselect },
	props: {
		// 부모의 입력 상태(searchOptions_). 초기화처럼 부모가 통째로 바꾸면 form 도 따라간다.
		options: { type: Object, required: true },
	},
	emits: ['search', 'clear', 'close'],
	data() {
		return {
			form: JSON.parse(JSON.stringify(this.options)),
			bdCateList: [],
			useAreaList: [],
			teamList: [],
			cateList: [],
			memList: [],
		};
	},
	watch: {
		options(v) {
			this.form = JSON.parse(JSON.stringify(v));
		},
	},
	created() {
		this.loadLists();
	},
	methods: {
		async loadLists() {
			const u = this.$store.getters.getUserInfo || {};
			const key = [u.mem_uid, this.$store.getters.getInstitution || ''].join('|');
			if (!listCache || listCacheKey !== key) {
				const [bdCate, useArea, team, teamCate, mem] = await Promise.all([
					this.$apiGET('/admin/api/map/bdCate'),
					this.$apiGET('/admin/api/map/useArea'),
					this.$apiGET('/admin/api/mem/code?part=team'),
					this.$apiGET('/admin/api/mem/code?part=team_cate'),
					this.$apiGET('/admin/api/setting/etc/mem'),
				]);
				const ok = [bdCate, useArea, team, teamCate, mem].every(Array.isArray);
				const lists = { bdCate: bdCate || [], useArea: useArea || [], team: team || [], teamCate: teamCate || [], mem: mem || [] };
				if (ok) {
					listCache = lists;
					listCacheKey = key;
				}
				this.applyLists(lists);
				return;
			}
			this.applyLists(listCache);
		},
		applyLists(l) {
			this.bdCateList = l.bdCate;
			this.useAreaList = l.useArea;
			this.teamList = l.team;
			this.cateList = l.teamCate;
			this.memList = l.mem;
		},
		btnStOption() {
			this.form.st_ = this.form.st ? SELL_STATUS_ALL.slice() : [];
		},
		search() {
			this.$emit('search', JSON.parse(JSON.stringify(this.form)));
		},
		close() {
			// 예전 팝업은 부모 상태를 바로 고쳤으므로, 검색 없이 닫아도 적은 조건이 남아 있었다.
			// 같은 동작을 위해 닫을 때도 입력값을 돌려준다.
			this.$emit('close', JSON.parse(JSON.stringify(this.form)));
		},
	},
};
</script>
